import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import 'rxjs/add/observable/throw';

import { PremadeMessage } from './premade-message.model';
import { PremadeMessageInterface } from './premade-message.interface';
import { PremadeMessageFactory } from './premade-message.factory';
import { AuthService } from 'app/shared/auth/auth.service';
import { environment } from 'environments/environment';

@Injectable()
export class PremadeMessageService {

    constructor(private http: HttpClient, private authService: AuthService) { }

    getAll(params: HttpParams): Observable<Array<PremadeMessage>> {
        return this.http
            // tslint:disable-next-line:max-line-length
            .get<PremadeMessageInterface[]>(`${environment.apiUrl}/v${environment.apiVersion}/premade-messages`, { params, headers: this.authService.headers() })
            .pipe(map(data => data
                .map(item => PremadeMessageFactory.fromObject(item)),
            ), catchError(this.errorHandler));
    }

    getSingle(id: string): Observable<PremadeMessage> {
        return this.http
            // tslint:disable-next-line:max-line-length
            .get<PremadeMessageInterface>(`${environment.apiUrl}/v${environment.apiVersion}/premade-messages/${id}`, { headers: this.authService.headers() })
            .pipe(map(item => PremadeMessageFactory.fromObject(item)),
                catchError(this.errorHandler)
            );
    }

    createOrUpdate(premadeMessage: PremadeMessage): Observable<any> {
        if (premadeMessage.id) {
            return this.http
                // tslint:disable-next-line:max-line-length
                .put(`${environment.apiUrl}/v${environment.apiVersion}/premade-messages/${premadeMessage.id}`, premadeMessage, { headers: this.authService.headers() })
                .pipe(map(item => PremadeMessageFactory.fromObject(item)),
                    catchError(this.errorHandler)
                );
        }
        return this.http
            // tslint:disable-next-line:max-line-length
            .post(`${environment.apiUrl}/v${environment.apiVersion}/premade-messages`, premadeMessage, { headers: this.authService.headers() })
            .pipe(map(item => PremadeMessageFactory.fromObject(item)),
                catchError(this.errorHandler)
            );
    }

    remove(id: string): Observable<any> {
        return this.http
            .delete(`${environment.apiUrl}/v${environment.apiVersion}/premade-messages/${id}`, { headers: this.authService.headers() })
            .pipe(
                catchError(this.errorHandler)
            );
    }

    private errorHandler(error: Error | any): Observable<any> {
        console.error('handleError', error)
        return Observable.throw(error);
    }
}



// WEBPACK FOOTER //
// ./src/app/settings/premade-messages/shared/premade-message.service.ts